import { forwardRef } from 'react'
import {
  FieldValues,
  useController,
  FieldPath,
  UseControllerProps,
} from 'react-hook-form'
import { TextField, TextFieldProps } from '@mui/material'

type FormTextFieldProps<FormValues extends FieldValues> = {
  name: FieldPath<FormValues>
  label?: string
  requiredErrorText?: string
  useControllerProps?: Omit<UseControllerProps<FormValues>, 'name'>
  shrinkLabel?: boolean
} & TextFieldProps

const FormTextField = forwardRef(function FormTextField<
  FormValues extends FieldValues,
>(
  {
    name,
    required,
    requiredErrorText,
    onBlur,
    onChange,
    useControllerProps,
    shrinkLabel,
    ...props
  }: FormTextFieldProps<FormValues>,
  ref: React.Ref<HTMLInputElement>,
) {
  const { field } = useController<FormValues>({
    name,
    ...useControllerProps,
    rules: {
      required: required && requiredErrorText,
      ...useControllerProps?.rules,
    },
  })
  return (
    <TextField
      required={required}
      {...props}
      {...field}
      inputRef={ref}
      slotProps={{
        ...(props.slotProps || {}),
        inputLabel: {
          shrink: shrinkLabel,
          ...(props.slotProps?.inputLabel || {}),
        },
      }}
      onBlur={(e) => {
        field.onBlur()
        onBlur?.(e)
      }}
      onChange={(e) => {
        field.onChange(e)
        onChange?.(e)
      }}
    />
  )
})

export default FormTextField
